<script setup>

import FooterMenu from "@/components/FooterMenu.vue";
import FooterMenuItem from "@/components/FooterMenuItem.vue";
import LanguageSwitch from "@/components/LanguageSwitch.vue";
import { useRouting } from "@/composables/routing.js";
const { href } = useRouting();
import { Link } from '@inertiajs/vue3'
</script>

<template>
    <footer class="text-primary mt-20">
        <div class="container px-5 py-24 mx-auto flex md:items-center lg:items-start md:flex-row md:flex-nowrap flex-wrap flex-col">
            <div class="w-64 flex-shrink-0 md:mx-0 mx-auto text-center md:text-left">
                <Link class="flex title-font font-medium items-center md:justify-start justify-center text-gray-900"
                      :href="href('/')"
                >
                    <img src="/assets/logo-500-100.png" alt="LAY7 cloud">
                </Link>
                <p class="mt-5 text-md text-gray-800">
                    {{ $t("The cloud for web applications: Fast, secure and easy to manage. Perfect for websites, onlineshops and backend applications. Cost-effective and uncomplicated.")}}
                </p>
            </div>
            <div class="flex-grow flex flex-wrap md:pl-20 -mb-10 md:mt-0 mt-10 md:text-left text-center">

                <footer-menu title="Solutions">
                    <footer-menu-item text="Website Hosting" href="/solutions#website-hosting" />
                    <footer-menu-item text="Shop Hosting" href="/solutions#shop-hosting" />
                    <footer-menu-item text="Agency Hosting" href="/solutions#agency-hosting" />
                    <footer-menu-item text="SaaS Hosting" href="/solutions#saas-hosting" />
                </footer-menu>

                <footer-menu title="Features">
                    <footer-menu-item text="Spaces" href="/features#spaces" />
                    <footer-menu-item text="Databases" href="/features#databases" />
                    <footer-menu-item text="Routes" href="/features#routes" />
                    <footer-menu-item text="Domains" href="/domains" />
                </footer-menu>

                <footer-menu title="Informations">
                    <footer-menu-item text="Pricing" href="/pricing" />
                    <footer-menu-item text="Terms" href="/legal/tos" />
                    <footer-menu-item text="Privacy" href="/legal/privacy" />
                    <footer-menu-item text="Widerrufsbelehrung" href="/legal/widerrufsbelehrung" locale="de" />
                    <footer-menu-item text="Imprint" href="/legal/imprint" />
                </footer-menu>

                <div class="flex justify-end">
                    <language-switch class="self-end"
                                     hide-label
                    />
                </div>
            </div>
        </div>
        <div class="bg-primary text-white">
            <div class="container mx-auto py-4 px-5 flex flex-wrap flex-col sm:flex-row">
                <p class="text-sm text-center sm:text-left">Copyright © {{ (new Date()).getFullYear() }} LAY7 cloud</p>
            </div>
        </div>
    </footer>
</template>
